import api from '@/api'


export default {
    reportDocument: (data:webpart.betterKolmar.Submit): Promise<boolean> => {
        return api.post({
            url: '/api/HK/Webpart/better/report',
            data : data
        });
    },

  }